import { SVGProps } from "react"
const RightelIcon = ({className = "size-8",color = 'fill-black dark:fill-white', ...props}: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 45" className={className} {...props}>
    <defs>
      <clipPath id="rightel">
        <path
          fill="#fff"
          stroke="#707070"
          d="M8110-14897h42v45h-42z"
          data-name="Rectangle 8087"
        />
      </clipPath>
    </defs>
    <g
      clipPath="url(#rightel)"
      data-name="Mask Group 367"
      transform="translate(-8110 14897)"
    >
      <g className={color} data-name="Group 45251">
        <g data-name="Group 15455">
          <path
            d="M8129.428-14878.507a7.514 7.514 0 1 1 7.53-7.432 7.481 7.481 0 0 1-7.53 7.432Zm1.033-1.8a5.717 5.717 0 1 0-5.707-5.746 5.719 5.719 0 0 0 5.706 5.751Z"
            data-name="Path 8416"
          />
          <path
            d="M8131.137-14875.62h-.274a1.479 1.479 0 0 0-.18-.039c-.387-.031-.782-.035-1.166-.094a10.177 10.177 0 0 1-6.114-3.219 10.106 10.106 0 0 1-2.71-5.993c-.023-.223-.051-.446-.078-.669v-.743c.012-.047.031-.1.039-.145.078-.591.117-1.193.243-1.776a10.353 10.353 0 0 1 11.781-7.956 10.193 10.193 0 0 1 6.474 3.818 10.121 10.121 0 0 1 2.155 5.234c.02.184.055.368.078.552v1.252a1.271 1.271 0 0 0-.043.164c-.031.278-.043.559-.09.833a10.223 10.223 0 0 1-4.475 6.994 9.955 9.955 0 0 1-5.476 1.748 1.25 1.25 0 0 0-.164.039Zm-9.446-10.413a7.749 7.749 0 1 0 7.748-7.741 7.765 7.765 0 0 0-7.748 7.741Z"
            data-name="Path 8415"
          />
        </g>
        <g data-name="Group 15454">
          <path
            d="M8115.248-14859.29a1.558 1.558 0 0 1 2.037-1.045v1.986c0 .659-.009 1.31 0 1.969a1.762 1.762 0 0 0 1.815 1.81c.7.009 1.4.009 2.1 0a1.759 1.759 0 0 0 1.848-1.861c0-3.356.043-6.7-.017-10.059-.027-1.404.817-1.849 1.951-1.652.009.154.026.317.026.479 0 2.423.026 4.854-.009 7.277a1.831 1.831 0 0 0 1.995 1.978c.822-.06 1.652-.009 2.483-.009a1.722 1.722 0 0 0 1.789-1.772 9.184 9.184 0 0 0-.01-1.281c-.111-1.07.848-1.678 1.978-1.378 0 .89-.009 1.781 0 2.679a1.757 1.757 0 0 0 1.678 1.769 1.845 1.845 0 0 0 2.166-1.481 7.133 7.133 0 0 0 0-1.541c-.111-1.1.779-1.729 1.943-1.447a33.25 33.25 0 0 1-.026 3.578 3.348 3.348 0 0 1-3.176 2.859 4.157 4.157 0 0 1-3.561-1.038 3.728 3.728 0 0 1-2.765 1.044c-.36-.017-.711.009-1.07 0a9.131 9.131 0 0 1-3.407-.325v.736a3.381 3.381 0 0 1-3.168 3.368c-1.121.06-2.251.051-3.373 0a3.354 3.354 0 0 1-3.133-3.21c-.017-.471 0-.942-.009-1.413a1.541 1.541 0 0 0-.085-.394Z"
            data-name="Path 8419"
          />
          <path
            d="M8146.751-14856.037c-.034.1-.086.205-.111.308a4.05 4.05 0 0 1-3 3.065 1.027 1.027 0 0 1-.171.026.6.6 0 0 1-.12-.026c0-.574-.009-1.147.009-1.729a.516.516 0 0 1 .205-.351 2.779 2.779 0 0 0 1.224-2.654c.017-1.335 0-2.68 0-4.015 0-1.053.437-1.49 1.507-1.515a4.218 4.218 0 0 0 .462-.043Z"
            data-name="Path 8420"
          />
          <path
            d="M8142.77-14856.432c-.6 0-1.181.017-1.764-.017-.077 0-.2-.248-.2-.377-.017-1.053-.009-2.114-.009-3.167v-6.505c0-1.335.608-1.849 1.969-1.635Z"
            data-name="Path 8421"
          />
          <path
            d="M8130.606-14866.858c0 .608.009 1.233-.009 1.858 0 .068-.146.18-.231.18-.565.017-1.13.009-1.686.009-.3-1.559.385-2.286 1.926-2.047Z"
            data-name="Path 8422"
          />
          <path
            d="M8133.225-14866.858v2.029c-.633 0-1.224.009-1.815-.017-.068 0-.18-.2-.188-.308-.103-1.336.557-1.918 2.003-1.704Z"
            data-name="Path 8423"
          />
          <path
            d="M8136.35-14852.656c-.009-.094-.017-.163-.017-.231v-1.738h1.952c.274 1.267-.274 2.251-1.935 1.969Z"
            data-name="Path 8424"
          />
          <path
            d="M8133.748-14852.672c0-.6-.009-1.181.009-1.764 0-.077.146-.214.223-.223.548-.017 1.1-.009 1.644-.009.347 1.414-.353 2.287-1.876 1.996Z"
            data-name="Path 8425"
          />
        </g>
      </g>
    </g>
  </svg>
)
export default RightelIcon
